export const cookies = () =>
  document.cookie
    .split('; ')
    .map((c) => c.split('='))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

export const TESCookieV2 = () => {
  try {
    return JSON.parse(atob(cookies()['TESCookieV2'].split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const isLoggedIn = Boolean(TESCookieV2());

export const GdprCookie = () => cookies()['TEScookieLawCookie'];

export const setGdprCookie = ({ domain }) => {
  // A write operation to document.cookie updates only cookies mentioned in it, but doesn’t touch other cookies.
  // https://javascript.info/cookie#writing-to-document-cookie

  const expires = new Date('2030-01-01').toUTCString();
  document.cookie = `TEScookieLawCookie=true; domain=${domain}; path=/; expires=${expires};`;
};
